module.exports = __webpack_public_path__ + "static/change-your-status-df905ee23b465b6ba0216ca9926bfc06.png";